module.exports = __webpack_public_path__ + "assets/img/Travel_005.ae417c9a-ps.jpg";